<template>
  <button class="btn" :class="props.isActive ? 'btn--active' : ''">
    <BellIcon v-if="!props.isActive" />
    <BellFullBgIcon v-else />
  </button>
</template>

<script setup>
  import { Props } from './props';
  //------------------------
  import BellIcon from '@/Groups/Notifications/private/svg/BellIcon.vue';
  import BellFullBgIcon from '@/Groups/Notifications/private/svg/BellFullBgIcon.vue';
  //------------------------
  const props = defineProps(Props());
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>